export function isDefined (value)
{
	return value !== null && value !== undefined;
}

export function valueIfNotUndefined (value)
{
	if (value !== undefined)
	{
		return value;
	}

	return undefined;
}